var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supervise"},[_c('ol',[_c('li',[_c('router-link',{attrs:{"to":"/TeamList","replace":""}},[_c('div',[_c('span',[_vm._v("服务团队")])])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/Check","replace":""}},[_c('div',[_c('span',[_vm._v("评估查验")])])])],1)]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b69127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Supervise.vue
// module id = xoB8
// module chunks = 0